<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.muniss_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-bulding"></i>
            </span>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.muniss_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 23%">Data Inicial</th>
                <th style="width: 23%">Data Final</th>
                <th style="width: 12%">Aliquota ISS</th>
                <th style="width: 12%">Aliquota Fora Município</th>
                <th style="width: 23%">Status</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in rowData.municipio_iss_vigencia"
                class="bg-gray-light"
                style="display: table-row"
              >
                <td>
                  {{ formatDate(item.dt_vigencia_ini) }}
                </td>
                <td>
                  {{ formatDate(item.dt_vigencia_fim) }}
                </td>
                <td>
                  {{ item.aliquota_iss }}
                </td>
                <td>
                  {{ item.aliquota_iss_fora_municipio }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
                <td>
                  <a
                    @click="onEditVigencia(item)"
                    v-b-tooltip
                    title="Editar"
                    v-if="getPermissionFw('municipioiss.update')"
                    ><i class="fa fa-edit"></i
                  ></a>
                  <span v-if="getPermissionFw('municipioiss.status')">
                    <a
                      v-if="item.status.valor == 2"
                      @click="onActivateDesactivate(1, item, true)"
                      v-b-tooltip
                      title="Ativar"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                    <a
                      v-if="item.status.valor == 1"
                      @click="onActivateDesactivate(2, item, true)"
                      v-b-tooltip
                      title="Inativar"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--.tab-content -->
      <MunicipioIssVigenciaForm ref="municipioissvigenciaform" />
    </div>
  </div>
</template>

  <script>
import moment from "moment";
import MunicipioIssVigenciaForm from "./MunicipioIssVigenciaForm.vue";
export default {
  components: {
    MunicipioIssVigenciaForm
  },
  data() {
    return {
      helpForm: new Form({
        statusRecord: [],
        params: [],
        statusRecord: [],
        status: ""
      })
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    formatDate(value, fmt = "D/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    onEditVigencia(data) {
      this.$refs.municipioissvigenciaform.onEdit(data);
    },
    onActivateDesactivate(action, data, tipo) {
      console.log(data);
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push(data.munissvig_id);
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach(obj => {
          this.helpForm.statusRecord.push(obj);
        });
      }
      this.$refs.municipioissvigenciaform.onActivateDesactivate(this.helpForm);
    }
  }
};
</script>
